/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GenerateNotificationEmailPreviewNotificationTypeParameter,
  GetReservationNotifications200ResponseInner,
  UpsertReservationNotificationRequest,
} from '../models/index';
import {
    GenerateNotificationEmailPreviewNotificationTypeParameterFromJSON,
    GenerateNotificationEmailPreviewNotificationTypeParameterToJSON,
    GetReservationNotifications200ResponseInnerFromJSON,
    GetReservationNotifications200ResponseInnerToJSON,
    UpsertReservationNotificationRequestFromJSON,
    UpsertReservationNotificationRequestToJSON,
} from '../models/index';

export interface GenerateNotificationEmailPreviewRequest {
    notificationType: GenerateNotificationEmailPreviewNotificationTypeParameter;
}

export interface UpsertReservationNotificationOperationRequest {
    notificationType: UpsertReservationNotificationNotificationTypeEnum;
    upsertReservationNotificationRequest?: UpsertReservationNotificationRequest;
}

/**
 * 
 */
export class NotificationsApi extends runtime.BaseAPI {

    /**
     */
    async generateNotificationEmailPreviewRaw(requestParameters: GenerateNotificationEmailPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['notificationType'] == null) {
            throw new runtime.RequiredError(
                'notificationType',
                'Required parameter "notificationType" was null or undefined when calling generateNotificationEmailPreview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/notifications/{notificationType}`.replace(`{${"notificationType"}}`, encodeURIComponent(String(requestParameters['notificationType']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async generateNotificationEmailPreview(requestParameters: GenerateNotificationEmailPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.generateNotificationEmailPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getReservationNotificationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetReservationNotifications200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reservations/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetReservationNotifications200ResponseInnerFromJSON));
    }

    /**
     */
    async getReservationNotifications(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetReservationNotifications200ResponseInner>> {
        const response = await this.getReservationNotificationsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async upsertReservationNotificationRaw(requestParameters: UpsertReservationNotificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['notificationType'] == null) {
            throw new runtime.RequiredError(
                'notificationType',
                'Required parameter "notificationType" was null or undefined when calling upsertReservationNotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/reservations/notifications/{notificationType}`.replace(`{${"notificationType"}}`, encodeURIComponent(String(requestParameters['notificationType']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertReservationNotificationRequestToJSON(requestParameters['upsertReservationNotificationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upsertReservationNotification(requestParameters: UpsertReservationNotificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertReservationNotificationRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const UpsertReservationNotificationOperationNotificationTypeEnum = {
    Confirmation: 'confirmation',
    Reminder: 'reminder',
    Modification: 'modification',
    Cancellation: 'cancellation',
    Experience: 'experience'
} as const;
export type UpsertReservationNotificationOperationNotificationTypeEnum = typeof UpsertReservationNotificationOperationNotificationTypeEnum[keyof typeof UpsertReservationNotificationOperationNotificationTypeEnum];
